import React from 'react'

const GestureContext = React.createContext(null)
GestureContext.displayName = 'GestureContext'
export default GestureContext
